import React from 'react';

const StripeSettingsModal = ({
  open,
  onClose,
  alertVariant,
  status,
  publishableKey,
  setPublishableKey,
  secretKey,
  setSecretKey,
  webhookSecret,
  setWebhookSecret,
  hasSecretKey,
  hasWebhookSecret,
  loading,
  onSave
}) => {
  if (!open) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Configurar Stripe</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="text-muted">
              Introduce las claves de Stripe para activar el pago con tarjeta en las facturas.
            </p>
            {status && (
              <div className={`alert alert-${alertVariant(status.type)}`}>
                {status.message}
              </div>
            )}
            {hasSecretKey && (
              <div className="alert alert-info py-2">Clave secreta guardada (no se muestra por seguridad).</div>
            )}
            {hasWebhookSecret && (
              <div className="alert alert-info py-2">Webhook secret guardado.</div>
            )}
            <form onSubmit={onSave}>
              <div className="mb-3">
                <label className="form-label">Clave publicable</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="pk_live_..."
                  value={publishableKey}
                  onChange={(e) => setPublishableKey(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Clave secreta</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="sk_live_..."
                  value={secretKey}
                  onChange={(e) => setSecretKey(e.target.value)}
                  required={!hasSecretKey}
                  disabled={loading}
                />
                {hasSecretKey && (
                  <div className="form-text">Déjalo vacío si no quieres cambiar la clave secreta.</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Webhook secret (necesario para confirmación automática de pagos)</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="whsec_..."
                  value={webhookSecret}
                  onChange={(e) => setWebhookSecret(e.target.value)}
                  disabled={loading}
                />
                {hasWebhookSecret && (
                  <div className="form-text">Déjalo vacío si no quieres cambiar el webhook secret.</div>
                )}
              </div>
              <div className="d-flex gap-2">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Guardando...' : 'Guardar credenciales'}
                </button>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StripeSettingsModal;
